import { render, staticRenderFns } from "./VerificationState.vue?vue&type=template&id=9857e2b8&scoped=true"
import script from "./VerificationState.vue?vue&type=script&lang=js"
export * from "./VerificationState.vue?vue&type=script&lang=js"
import style0 from "./VerificationState.vue?vue&type=style&index=0&id=9857e2b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9857e2b8",
  null
  
)

export default component.exports